// Assets are fingerprinted by git commit hash at build time. If a tab stays
// open across a deploy, an old hashed asset path (e.g. the pdfjs worker) can
// 404 against the new deploy; the SPA's catch-all rewrite then serves
// index.html instead, and the browser throws these exact parse errors trying
// to run it as JS. Treat them as a signal the loaded frontend is stale.
const STALE_ASSET_ERROR_PATTERN =
  /Unexpected token '<'|is not a valid JavaScript MIME type|Failed to fetch dynamically imported module/i;

export default function isStaleAssetError(
  message: string | null | undefined,
): boolean {
  return !!message && STALE_ASSET_ERROR_PATTERN.test(message);
}
